import React from "react";

function LegalPage({ title, updated, sections }) {
  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-20">
      <p className="font-sans text-[10px] tracking-luxe uppercase text-[#C8A97E]">MOIRÉ</p>
      <h1 className="font-serif text-4xl md:text-5xl text-[#F5F2EA] mt-3">{title}</h1>
      <p className="font-sans text-xs text-[#8A8170] mt-3">Last updated {updated}</p>
      <div className="gold-line my-10" />
      <div className="space-y-10">
        {sections.map((s) => (
          <div key={s.h}>
            <h2 className="font-serif text-2xl text-[#F5F2EA]">{s.h}</h2>
            <p className="font-sans text-sm text-[#F5F2EA]/70 mt-3 leading-relaxed">{s.p}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export function Privacy() {
  return (
    <LegalPage title="Privacy Policy" updated="June 2026" sections={[
      { h: "Your images", p: "Photographs you upload are used only to analyse your fashion item and generate styling recommendations. They are stored securely, are never shown publicly, and are not shared with third parties." },
      { h: "What we process", p: "We process the visual content of your image to identify the item, its colour, pattern and material. We also store the resulting analysis and any looks you choose to save to your account." },
      { h: "Your control", p: "You can delete saved looks at any time. Future updates will let you delete uploaded images and manage privacy settings directly from your profile." },
      { h: "Accounts", p: "If you create an account, we store your email and an encrypted password. We never store passwords in plain text." },
      { h: "Contact", p: "For any privacy request, reach us at privacy@moire.live." },
    ]} />
  );
}

export function Terms() {
  return (
    <LegalPage title="Terms of Service" updated="June 2026" sections={[
      { h: "Styling guidance", p: "MOIRÉ offers informed styling recommendations based on colour relationships and styling conventions. Fashion is subjective; our recommendations are guidance, not absolute rules, and you remain free to style as you wish." },
      { h: "Acceptable use", p: "Please upload images you have the right to use. Do not upload unlawful or harmful content." },
      { h: "Availability", p: "We aim for a reliable experience but do not guarantee uninterrupted availability. Features marked Coming Soon are in development." },
      { h: "Brand", p: "MOIRÉ is a standalone product identity, powered by Kendi Collections. The MOIRÉ name, mark and tagline are protected." },
      { h: "Contact", p: "Questions? Reach us at hello@moire.live." },
    ]} />
  );
}
